module.exports = __webpack_public_path__ + "static/media/sniper-2.23c0899c.png";